import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-drake-settings',
    templateUrl: './drake-settings.component.html',
    styleUrls: ['./drake-settings.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule]
})
export class DrakeSettingsComponent implements OnInit {
    constructor(private router: Router) { }

    ngOnInit(): void {
        const user = localStorage.getItem('user');
        if (user) {
            try {
                const userObj = JSON.parse(user);
                const userId = userObj.id;
                if (userId) {
                    this.router.navigateByUrl(`/d/SETTINGS/f/${userId}`, { skipLocationChange: true });
                } else {
                    console.error('User ID not found in local storage');
                }
            } catch (error) {
                console.error('Error parsing user JSON:', error);
            }
        } else {
            console.error('User not found in local storage');
        }
    }
}
